import {gql} from "@apollo/client";

export const GET_ORGANIZATION_BY_SLUG = gql`
    query OrganizationBySlug($organizationSlug: String!) {
        organization(organizationSlug: $organizationSlug) {
            id
            slug
            activeSubscription {
                plan {
                    id
                    name
                    features {
                        key
                    }
                }
            }
        }
    }
`;

export const GET_DIVISIONS = gql`
    query Divisions ($organizationSlug: String!, $profileId: Int!, $page: Int, $pageSize: Int, $statusFilter: String) {
       organization(organizationSlug: $organizationSlug, profileId: $profileId) {
           id
       }
       divisions(organizationSlug: $organizationSlug, profileId: $profileId, page: $page, pageSize: $pageSize, statusFilter: $statusFilter){
            objects{
                id
                slug
                organization{
                    id
                    name
                    slug
                }
                name
                competitionLevel
                ageGroup
                description
                logo
                mountDistance
                pitchLimit
                gameDuration
                restingGames
                sport{
                    key
                    name
                  }
                isOpen
                activeSeason {
                    id
                    name
                    startDate
                    endDate
                    state
                    slug
                }
                seasons {
                    id
                    name
                    slug
                }
                waivers {
                    id
                    title
                }
            }
            page
            pages
            hasNext
            hasPrev
       }
    }
`;
